import styled, { css } from 'styled-components';
import { spacing } from 'ui/theme/utils';

export const Title = ({ children, type = 'h1', variant = 'default', ...rest }) => {
  return (
    <Header as={type} variant={variant} {...rest}>
      {children}
    </Header>
  );
};

const Header = styled.h1`
  cursor: default;
  ${({ minWidth }) => minWidth && `min-width: ${minWidth};`}
  ${({ flexGrow }) => flexGrow && `flex-grow: ${flexGrow};`}
  ${({ textAlign = 'left' }) => textAlign && `text-align: ${textAlign};`}
  ${({ variant }) => {
    switch (variant) {
      case 'dark':
        return css`
          font-size: ${({ fontSize = '26px' }) => fontSize};
          font-weight: ${({ fontWeight = 'bold' }) => fontWeight};
          letter-spacing: ${({ letterSpacing = '0.04em' }) => letterSpacing};
          color: ${({ theme }) => theme.colors.black};
        `;
      case 'grey':
      case 'darkGrey':
        return css`
          font-size: ${({ fontSize = '16px' }) => fontSize};
          font-weight: ${({ fontWeight = 'normal' }) => fontWeight};
          letter-spacing: ${({ letterSpacing = '0.04em' }) => letterSpacing};
          line-height: 26px;
          color: ${({ theme }) => theme.colors[variant]};
        `;
      case 'primary':
        return css`
          font-size: ${({ fontSize = '22px' }) => fontSize};
          font-weight: ${({ fontWeight = 500 }) => fontWeight};
          letter-spacing: ${({ letterSpacing = '0.04em' }) => letterSpacing};
          color: ${({ theme }) => theme.colors.primary};
        `;
      default:
        return css`
          font-size: ${({ fontSize = '19px' }) => fontSize};
          font-weight: ${({ fontWeight = 500 }) => fontWeight};
          letter-spacing: ${({ letterSpacing = '0.86px' }) => letterSpacing};
          color: ${({ theme }) => theme.colors.tertiary};
        `;
    }
  }}
  ${(props) => spacing(props)}
`;
